export default __webpack_public_path__ + "static/media/rodape_mobile.73606fe4.svg";